import { render, staticRenderFns } from "./detailLbRight.vue?vue&type=template&id=1ce53f4b&scoped=true"
import script from "./detailLbRight.vue?vue&type=script&lang=js"
export * from "./detailLbRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce53f4b",
  null
  
)

export default component.exports